export const resolveCartSectionHTML = async (
  data,
  sectionId: string,
  loadFallback: () => Promise<string>,
): Promise<string> => {
  const sectionHTML = data.sections?.[sectionId]

  return sectionHTML || loadFallback()
}
